import { render, staticRenderFns } from "./ModalWms.vue?vue&type=template&id=8240edf8&scoped=true"
import script from "./ModalWms.vue?vue&type=script&lang=js"
export * from "./ModalWms.vue?vue&type=script&lang=js"
import style0 from "./ModalWms.vue?vue&type=style&index=0&id=8240edf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8240edf8",
  null
  
)

export default component.exports